module.exports = {
	DAY_FIRST_CHARGE_EVENT: "DayChargetEvent.DAY_FIRST_CHARGE_EVENT",//每日首充
}